
<div [ngStyle]="{ 'display' : navaidController.active? 'block' : 'none'}" [ngClass]="tabsService.minimizeScreenMode ? 'bottom-menu minimized' : ''">
  <form autocomplete="off"  class="active" id="ngForm" name="ngForm" #ngForm="ngForm">
    <div class="fields__block">
      <div class="fields__block__section">
        <div class="title">
          <h4>Calculation Mode</h4>
          <span> </span>
        </div>
        <div class="input-fields">
          <div>
            <input type="checkbox"
              [(ngModel)]="navaidController.navaidFromMapModel.singleLevel"
              [checked]="navaidController.navaidFromMapModel.singleLevel"
              (change)="this.changeSingleLevel()"
              name="useSingleLevel"/>
              <label for="">Use Single Level</label>
          </div>
        </div>
        <div class="input-fields">
          <div>
            <input type="checkbox"
            [(ngModel)]="navaidController.navaidFromMapModel.onlyClickedPoint"
            [checked]="navaidController.navaidFromMapModel.onlyClickedPoint"
            (change)="navaidController.useOnlyClickPointChanged()"
            name="useOnlyClickedPoints"/>
            <label for="">Use only clicked point</label>
          </div>
        </div>
        <div class="dropdown-fields">
          <div>
            <label for="">Perform</label>
            <select
                name="Perform"
                required
                [(ngModel)]="navaidController.navaidFromMapModel.perform"
                [disabled]="navaidController.navaidFromMapModel.onlyClickedPoint"
              >
                <option value="CoveragePerformance">Both(Coverage + Performance)</option>
                <option value="Coverage">Coverage</option>
                <option value="Performance">Performance</option>
              </select>
          </div>
        </div>
      </div>
      <div class="fields__block__section">
        <div class="title">
          <h4>Single Altitude Parameteres (AMSL)</h4>
          <span> </span>
        </div>
        <div class="input-fields">
          <div>
            <label for="">Single Level Altitude</label>
            <div class="coordenates">
              <input id="singleLevelAltitudeFeet" name="singleLevelAltitudeFeet" #singleLevel='ngModel' [(ngModel)]="navaidController.navaidFromMapModel.singleAltitude"
              (ngModelChange)="navaidController.navaidFromMapModel.singleAltitudeMeters=utilsService.feetToMeters($event)"
              type="number" style="width: 30%" [required]="navaidController.navaidFromMapModel.singleLevel" [disabled]="!navaidController.navaidFromMapModel.singleLevel"/><span>[ft]</span>
              <input id="singleLevelAltitudeMeters" name="singleLevelAltitudeMeters" [(ngModel)]="navaidController.navaidFromMapModel.singleAltitudeMeters"
              (ngModelChange)="navaidController.navaidFromMapModel.singleAltitude=utilsService.metersToFeet($event)"
              type="number" style="width: 30%" [required]="!navaidController.navaidFromMapModel.singleLevel" [disabled]="!navaidController.navaidFromMapModel.singleLevel"/><span>[m]</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="fields__block">
      <div class="fields__block__section">
        <div class="title">
          <h4>Alt. Range Parameteres (AMSL)</h4>
          <span> </span>
        </div>
        <div class="input-fields">
          <div>
            <label for="">Max Altitude</label>
            <div class="coordenates">
              <input id="maxAltitudeAltitudeFeet" name="maxAltitudeAltitudeFeet" type="number" #maxAltitude='ngModel' [(ngModel)]="navaidController.navaidFromMapModel.maxAltitude"
              (ngModelChange)="navaidController.navaidFromMapModel.maxAltitudeMeters=utilsService.feetToMeters($event)"
              style="width: 30%" [required]="!navaidController.navaidFromMapModel.singleLevel" [disabled]="navaidController.navaidFromMapModel.singleLevel"/><span>[ft]</span
              ><input id="maxAltitudeAltitudeMeters" name="maxAltitudeAltitudeMeters" [(ngModel)]="navaidController.navaidFromMapModel.maxAltitudeMeters"
              (ngModelChange)="navaidController.navaidFromMapModel.maxAltitude=utilsService.metersToFeet($event)"
              type="number" style="width: 30%" [required]="!navaidController.navaidFromMapModel.singleLevel" [disabled]="navaidController.navaidFromMapModel.singleLevel"/><span>[m]</span>
            </div>
          </div>
          <div>
            <label for="">Min Altitude</label>
            <div class="coordenates">
              <input id="minAltitudeFeet" name="minAltitudeFeet" #minAltitude='ngModel' [(ngModel)]="navaidController.navaidFromMapModel.minAltitude"
              (ngModelChange)="navaidController.navaidFromMapModel.minAltitudeMeters=utilsService.feetToMeters($event)"
              type="number" style="width: 30%" [required]="!navaidController.navaidFromMapModel.singleLevel" [disabled]="navaidController.navaidFromMapModel.singleLevel"/><span>[ft]</span
              ><input id="minAltitudeMeters" name="minAltitudeMeters" [(ngModel)]="navaidController.navaidFromMapModel.minAltitudeMeters"
              (ngModelChange)="navaidController.navaidFromMapModel.minAltitudeMeters=utilsService.metersToFeet($event)"
              type="number" style="width: 30%" [required]="!navaidController.navaidFromMapModel.singleLevel" [disabled]="navaidController.navaidFromMapModel.singleLevel"/><span>[m]</span>
            </div>
          </div>
          <div>
            <label for="">Altitude Increment</label>
            <div class="coordenates">
              <input id="altitudeIncrementFeet" name="altitudeIncrementFeet" #altitudeIncrement='ngModel' [(ngModel)]="navaidController.navaidFromMapModel.altitudeInterval"
              (ngModelChange)="navaidController.navaidFromMapModel.altitudeIntervalMeters=utilsService.feetToMeters($event)"
              type="number" style="width: 30%" [required]="!navaidController.navaidFromMapModel.singleLevel" [disabled]="navaidController.navaidFromMapModel.singleLevel"/><span>[ft]</span
              ><input id="altitudeIncrementMeters" name="altitudeIncrementMeters" [(ngModel)]="navaidController.navaidFromMapModel.altitudeIntervalMeters"
              (ngModelChange)="navaidController.navaidFromMapModel.altitudeInterval=utilsService.metersToFeet($event)"
                type="number" style="width: 30%" [required]="!navaidController.navaidFromMapModel.singleLevel" [disabled]="navaidController.navaidFromMapModel.singleLevel"/><span>[m]</span>
            </div>
          </div>
        </div>
      </div>
      <div class="fields__block__section">
        <div class="title">
          <h4>DME Parameters</h4>
          <span> </span>
        </div>
        <div class="input-fields">
          <div>
            <label for="">DOC</label>
            <input
              required
              maxlength="9"
              [(ngModel)]="navaidController.navaidFromMapModel.doc"
              type="number"
              name="DOC"
              id="doc"
            /><span>[nm]</span>
          </div>
        </div>
      </div>
    </div>
    <div class="fields__btn">
      <button
        type="button"
        [ngClass]="navaidController.navaidFromMapModel.latitude!= null && navaidController.navaidFromMapModel.longitude != null ? 'blue' : 'gray'"
        (click)="calculateLastPosition();"
        [disabled]="navaidController.navaidFromMapModel.latitude == null || navaidController.navaidFromMapModel.longitude == null"
      >Calculate on last Position</button>
      <button
        type="button"
        [ngClass]="ngForm.form.valid ? 'blue' : 'gray'"
        (click)="calculateOnCoordinates();"
        [disabled]="!ngForm.form.valid"
      >Calculate on Coordinates</button>
      <button
        type="button"
        [ngClass]="navaidController.unlockAcceptNavaid ? 'blue' : 'gray'"
        (click)="acceptNavaid();"
        [disabled]="!navaidController.unlockAcceptNavaid"
      >Accept NavAid</button>
    </div>
  </form>


</div>
